import { SummernoteDirective } from './../../shared/forms/editors/summernote.directive';
import { Component, OnInit, ViewChild, TemplateRef, Input } from '@angular/core';
import { BsModalRef, BsModalService, TypeaheadMatch } from 'ngx-bootstrap';
import { NotificationService } from '../../shared/utils/notification.service';
import { AssetEmailDto } from 'app/client-core/dtos/asset-email.model';
import { TacticService } from 'app/client-core/services/tactic.service';
import { ValidationMessage } from 'app/validation';
import { SummernoteAttachDirective } from 'app/shared/forms/editors/summernote-attach.directive';
import { TacticAssetslistItemDTO } from 'app/client-core/dtos/tactics.model';
import { UserService } from 'app/client-core/services/user.service';
import { Observable } from 'rxjs';

const $ = jQuery;
@Component({
    selector: 'asset-email-modal',
    templateUrl: './asset-email.modal.component.html',
    styleUrls: [
        './asset-email.scss'
    ]
})
export class AssetEmailModalComponent implements OnInit {
    ready: boolean;
    dto = new AssetEmailDto();

    @Input() downloadURL: string;
    @Input() tacticId: number;
    @Input() tacticName: string;
    @Input() tactics: Array<TacticAssetslistItemDTO>;
    @Input() multiple: boolean;
    items: Array<any> = [];

    submitted: boolean;
    public validationMessages: ValidationMessage;

    columns = Observable.of([
        { prop: "id", name: "Id", flexGrow: 1 },
        { prop: "emailAddress", name: "Email", flexGrow: 3 },
    ]);

    constructor(
        public modalRef: BsModalRef,
        private notificationService: NotificationService,
        private tacticService: TacticService,
        public userService: UserService
    ) {
    }

    ngOnInit() {
        this.ready = true;
        // this.dto.additionalBody = `<a href="${this.downloadURL}">${this.downloadURL}</a>`;
    }

    close(): void {
        this.modalRef.hide();
    }

    sendEmail() {
        this.submitted = false;
        if (!this.canSubmit()) {
            this.submitted = true;
            this.validationMessages = new ValidationMessage(null, true, 'There were some validation erros').isDanger();
            return;
        }

        this.dto.additionalBody = $('.note-editable').html();
        this.dto.additionalBody += `
            <p>
            The following link has been shared with you and will expire in 4 days.<br>
            </p>
        `;
        if (!this.multiple) {
            this.dto.additionalBody += `
                <p>Please download link here: <a href="${this.downloadURL}">${this.tacticName}</a></p>
            `
        } else {
            const itemsString = this.tactics.map(t => {
                return `<li><a href="${(t as any).downloadURL}">${t.tacticTacticName}</a></li>`;
            }).join('');
            this.dto.additionalBody += `
                <p>Please download links here: <br> <ul style="list-style-type: disc">${itemsString}</ul></p>
            `
        }
        this.dto.to = this.items.join(',');
        this.tacticService.sendAssetLinkEmail(this.dto).subscribe(response => {
            console.log(response);
            this.validationMessages = new ValidationMessage(null, true, 'Email sent').isSuccess();
            this.close();
        })
    }

    canSubmit() {
        return this.isToValid() && this.dto.subject && this.isBodySizeValid();
    }

    isToValid() {
        return this.items && this.items.length > 0;
    }

    isBodySizeValid() {
        const additionalBody = $('.note-editable').html()
        if (!additionalBody) {
            return false;
        }
        return additionalBody.length < 5000;
    }

    getFilesString() {
        return this.tactics.map(t => {
            return `<li><a href="${(t as any).downloadURL}" target="_blank">${t.tacticTacticName}</a></span></li>`;
        }).join('');
    }
}





// WEBPACK FOOTER //
// ./src/app/+assets/asset-email-modal/asset-email.modal.component.ts